import { InputHTMLAttributes, forwardRef, ReactNode } from 'react'
import { cn } from '../../utils/cn'

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: boolean
  icon?: ReactNode
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, error, icon, disabled, ...props }, ref) => {
    const baseStyles = 'flex h-10 w-full rounded-md border bg-white px-3 py-2 text-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-gray-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50'

    const variants = {
      default: 'border-gray-300 focus-visible:ring-blue-600',
      error: 'border-red-500 focus-visible:ring-red-600',
    }

    if (icon) {
      return (
        <div className="relative">
          <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
            {icon}
          </div>
          <input
            ref={ref}
            className={cn(
              baseStyles,
              error ? variants.error : variants.default,
              'pl-10',
              className
            )}
            disabled={disabled}
            {...props}
          />
        </div>
      )
    }

    return (
      <input
        ref={ref}
        className={cn(
          baseStyles,
          error ? variants.error : variants.default,
          className
        )}
        disabled={disabled}
        {...props}
      />
    )
  }
)

Input.displayName = 'Input'

export default Input
